import React from "react";
import { useRoutes } from "react-router-dom";
import Home from "./pages/Home";
import Signup from "./pages/Auth/Signup";
import Dashboard from "./pages/Dashboard";
import TermsAndCondition from "./pages/TermsConditionPage";
import ContactUsPage from "./pages/ContactUsPage";
import Dot from "./pages/DotPage";
import StateCityCountryPage from "./pages/StateCityCountryPage";
import DesignBuildPage from "./pages/DesignBuildPage";
import PrivatePage from "./pages/Private";
import DirectoryPage from "./pages/Directory";
import CalanderPage from "./pages/Calander";
import LoginPage from "./pages/Auth/Login";
import UserProfile from "./pages/Profile/UserProfile";
import FormsPage from "./pages/Forms";
import UploadingRequest from "./pages/UploadingRequest";
import MarketingPage from "./pages/Marketing";
import DotSupportServicePage from "./pages/DotSupportService";
import WAH from "./pages/WAH";
import CCN from "./pages/CCN";
import MYPROJECTS from "./pages/MyProjects";
import MeetingAndAttandance from "./pages/MeetingAndAttandancePage";
import ReactionTimeGame from "./pages/random";
import NotFound from "./pages/page404";
import ResetPassword from "./pages/Reset_password";
import ProtectedRoute from "./components/Guard/ProtectedRoute";
import MRB from "./pages/MRB";
import AL_TEMP from "./pages/TempData/AL_TempData";
import AGENCY_REPORT from "./pages/AgencyReport";
import VendorFormPage from "./pages/VendorForm";
import UserTypeProtectedRoute from "./components/Guard/UserTypeProtectedRoute";
import AlreadyLoginProtectedRoute from "./components/Guard/AlreadyLoginProtectedRoute";
import Specialities from "./pages/Specialities";
import EconomicImpactForm from "./pages/EconomicForm";
export default function Router() {
  let isLoggedIn =
    localStorage.getItem("accessToken") &&
    localStorage.getItem("accessToken") !== "undefined"
      ? true
      : false;

  if (
    localStorage.getItem("loggedInUserInfo") &&
    localStorage.getItem("loggedInUserInfo") !== "undefined"
  ) {
    const loggedInUser = JSON.parse(
      localStorage.getItem("loggedInUserInfo") || "[]",
    );
  } else {
    localStorage.clear();
  }

  const routes = useRoutes([
    { path: "/", element: <Home /> },
    { path: "/signup", element: <Signup /> },
    { path: "/login", element: <LoginPage /> },
    { path: "/termsandcondition", element: <TermsAndCondition /> },
    { path: "/vendorForm", element: <VendorFormPage /> },
    { path: "/contactus", element: <ContactUsPage /> },

    { path: "/economicImpactForm", element: <EconomicImpactForm /> },
    // Protected Routes
    {
      path: "/dashboard",
      element: (
        <ProtectedRoute isLoggedIn={isLoggedIn}>
          <Dashboard />
        </ProtectedRoute>
      ),
    },
    {
      path: "/dot",
      element: (
        // <ProtectedRoute isLoggedIn={isLoggedIn}>
        <Dot />
        // </ProtectedRoute>
      ),
    },
    {
      path: "/statecitycountry",
      element: (
        <ProtectedRoute isLoggedIn={isLoggedIn}>
          <StateCityCountryPage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/designbuild",
      element: (
        <ProtectedRoute isLoggedIn={isLoggedIn}>
          <DesignBuildPage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/private",
      element: (
        <ProtectedRoute isLoggedIn={isLoggedIn}>
          <PrivatePage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/directory",
      element: (
        <ProtectedRoute isLoggedIn={isLoggedIn}>
          <DirectoryPage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/calander",
      element: (
        <ProtectedRoute isLoggedIn={isLoggedIn}>
          <CalanderPage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/profile",
      element: (
        <ProtectedRoute isLoggedIn={isLoggedIn}>
          <UserProfile />
        </ProtectedRoute>
      ),
    },
    {
      path: "/forms",
      element: (
        <ProtectedRoute isLoggedIn={isLoggedIn}>
          <FormsPage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/uplodingRequest",
      element: (
        <ProtectedRoute isLoggedIn={isLoggedIn}>
          <UploadingRequest />
        </ProtectedRoute>
      ),
    },
    {
      path: "/add_projects",
      element: (
        <ProtectedRoute isLoggedIn={isLoggedIn}>
          <UploadingRequest />
        </ProtectedRoute>
      ),
    },
    {
      path: "/marketing",
      element: (
        <ProtectedRoute isLoggedIn={isLoggedIn}>
          <MarketingPage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/dotsupportservice",
      element: (
        <ProtectedRoute isLoggedIn={isLoggedIn}>
          <DotSupportServicePage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/wah",
      element: (
        <ProtectedRoute isLoggedIn={isLoggedIn}>
          <WAH />
        </ProtectedRoute>
      ),
    },
    {
      path: "/ccn",
      element: (
        <ProtectedRoute isLoggedIn={isLoggedIn}>
          <CCN />
        </ProtectedRoute>
      ),
    },
    {
      path: "/myprojects",
      element: (
        <ProtectedRoute isLoggedIn={isLoggedIn}>
          <MYPROJECTS />
        </ProtectedRoute>
      ),
    },
    {
      path: "/Reports",
      element: (
        <ProtectedRoute isLoggedIn={isLoggedIn}>
          <MeetingAndAttandance />
        </ProtectedRoute>
      ),
    },
    {
      path: "/ReactionTimeGame",
      element: (
        <ProtectedRoute isLoggedIn={isLoggedIn}>
          <ReactionTimeGame />
        </ProtectedRoute>
      ),
    },
    {
      path: "/MRB_dashboard",
      element: (
        <ProtectedRoute isLoggedIn={isLoggedIn}>
          <MRB />
        </ProtectedRoute>
      ),
    },
    {
      path: "/reset-password",
      element: <ResetPassword />,
    },
    {
      path: "/temp_data",
      element: (
        <ProtectedRoute isLoggedIn={isLoggedIn}>
          <AL_TEMP />
        </ProtectedRoute>
      ),
    },
    {
      path: "/agency_report",
      element: (
        <ProtectedRoute isLoggedIn={isLoggedIn}>
          <AGENCY_REPORT />
        </ProtectedRoute>
      ),
    },
    {
      path: "/mapped_specialities",
      element: (
        <ProtectedRoute isLoggedIn={isLoggedIn}>
          <Specialities />
        </ProtectedRoute>
      ),
    },
    {
      path: "*",
      element: <NotFound />,
    },
  ]);
  return routes;
}
